import React, { memo } from 'react';
import RecentSearchItem from "./RecentSearchItem";
import translate from "../../../../utilities/translator";
import { IMAGE_CDN } from "../../../../constants/constants";

const RecentSearches = ({ onApply }) => {
  const recentSearches = JSON.parse(localStorage.getItem('_recentSearches'));

  return (
    <div className={`history ${recentSearches ? '': 'history__hide'}`}>
      <div className="history__label">
        <span>{translate('holidayFinder.recentSearch.title')}</span>
        <i className="ri-time-line" />
      </div>

      {recentSearches ? (
        <div className="history__list">
          {recentSearches.map((item, i) => <RecentSearchItem key={i} item={item} onApply={onApply} />)}
        </div>
      ) : (
        <div className="history__empty">
          <img src={`${IMAGE_CDN}/recent-searches-nothing-found.png`} alt={translate('holidayFinder.recentSearch.noRecentSearches')} />
          <p>{translate('holidayFinder.recentSearch.noRecentSearches')}</p>
        </div>
      )}
    </div>
  );
}

export default memo(RecentSearches)
